import React from "react";
import styled from "styled-components";
import { Layout } from "../components/layout/Layout";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-4);
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: var(--spacing-6);
  color: var(--color-text-primary);
`;

const Section = styled.section`
  margin-bottom: var(--spacing-6);
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-3);
`;

const Content = styled.div`
  color: var(--color-text-secondary);
  line-height: 1.6;

  p {
    margin-bottom: var(--spacing-3);
  }

  ul {
    margin-bottom: var(--spacing-3);
    padding-left: var(--spacing-4);
  }

  li {
    margin-bottom: var(--spacing-2);
  }
`;

const LegalNotice = () => {
  return (
    <Layout>
      <Container>
        <Title>Mentions Légales</Title>

        <Section>
          <SectionTitle>1. Informations Générales</SectionTitle>
          <Content>
            <p>
              Cinedelux.com est un site d'information dédié aux films et séries.
              <br />
              Contact : ytbrelaxmusic@gmail.com
              <br />
              Hébergement : Netlify
            </p>
          </Content>
        </Section>

        <Section>
          <SectionTitle>
            2. Droits d'Auteur et Propriété Intellectuelle
          </SectionTitle>
          <Content>
            <p>
              Tous les contenus présents sur ce site, y compris les textes,
              images, logos, et vidéos, sont protégés par les lois sur le droit
              d'auteur et la propriété intellectuelle. Toute reproduction,
              distribution, modification ou exploitation non autorisée des
              contenus du site est strictement interdite.
            </p>
            <p>
              Les noms, marques, et logos liés aux films et séries appartiennent
              à leurs détenteurs respectifs. Cinedelux.com ne revendique aucun
              droit sur ces éléments et les utilise uniquement à des fins
              d'information et d'analyse.
            </p>
          </Content>
        </Section>

        <Section>
          <SectionTitle>3. Limitation de Responsabilité</SectionTitle>
          <Content>
            <p>
              Cinedelux.com s'efforce de fournir des informations précises et
              mises à jour sur les films et séries. Cependant, nous ne
              garantissons pas l'exactitude ou l'exhaustivité des informations
              publiées. Les visiteurs utilisent le site à leurs propres risques.
            </p>
            <p>
              Cinedelux.com ne peut être tenu responsable des erreurs,
              omissions, ou des éventuels dommages directs ou indirects liés à
              l'utilisation du site.
            </p>
          </Content>
        </Section>

        <Section>
          <SectionTitle>4. Liens Externes</SectionTitle>
          <Content>
            <p>
              Le site Cinedelux.com peut contenir des liens vers des sites
              tiers. Nous ne sommes pas responsables du contenu ou des pratiques
              de ces sites.
            </p>
          </Content>
        </Section>
      </Container>
    </Layout>
  );
};

export default LegalNotice;
